import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { UserModel } from "@/modules/users/models/userModel"

@Serializable
export class UserListViewSpace extends UserModel {
  created: string = ""

  constructor(
    data: {
      uid: string
      email: string
      firstname: string
      lastname: string
      phone: string
      title: string
      created: string
      spaceUserId: string
      roles: string[]
    } | null = null,
  ) {
    super(data)

    if (data) {
      this.created = data.created
      this.roles = data.roles || []
    }
  }
}
